
import axios from "axios";

export default axios.create({
  baseURL: "https://milano-node.onrender.com",
});